import { UseQueryResult } from '@tanstack/react-query'
import { BoardListDataType, getBoardList } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import dayjs from 'dayjs'
import { useAtomValue } from 'jotai'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  boardCode: string
  useErrorBoundary?: boolean
}

export type QuizType = 'TEXT_SELECT' | 'TRUE_FALSE'
export type BoardAdditionalData = {
  // 인벤토리 코드용
  ads?: {
    adMissionInventoryCodes?: string[]
  }
  // 데일리 퀴즈 미션용
  quizMission?: {
    category: string
    quiz: string
    quizType: QuizType
    answerOptions: string[]
    correctAnswer: string
    correctAnswerDesc: string
    incorrectAnswer: string
    incorrectAnswerDesc: string
    landingCTA?: string
  }
  adsTheme?: {
    bgImage: string
    stepsInfoBgColor: string
    headerFontColor: string
    overFlowBgColor: string
  }
}

function useGetBoardList(props: Props): UseQueryResult<BoardListDataType, AxiosError> {
  const { boardCode } = props
  const storageMock = useAtomValue(storageMockEnabled)
  const now = dayjs().format('YYYYMMDD')

  return useQueryWrapper<BoardListDataType, AxiosError>(
    KEYS.POINT_INVENTORY_CODES(boardCode, now),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get<BoardListDataType>(
          `/proxy/square-admin/user/api/boards/${boardCode}`
        )
        return data
      } else {
        const { data } = await getBoardList(true, { boardCode, pageSize: 100, boardStatus: '1' })
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetBoardList }
